module.exports = __webpack_public_path__ + "static/media/1829.a6e0833e.jpg";